import { useMemo, useRef } from 'react';
import { normalizeDate, isEqualDate } from '../utils';

export default function useNormalizedValue(value: string | Date) {
  const normalizedValue = useRef<string | Date | undefined>(undefined);
  return useMemo(() => {
    if (isEqualDate(value, normalizedValue.current || undefined))
      return normalizedValue.current;
    normalizedValue.current = normalizeDate(value);
    return normalizedValue.current;
  }, [value]);
}
